// extracted by mini-css-extract-plugin
module.exports = {"ParametersContainer":"ParametersQ_ParametersContainer__ehPXS","ParamContainer":"ParametersQ_ParamContainer__1MYY5","Slider":"ParametersQ_Slider__2GcKd"};